export default function BankDetailsCard() {
  return (
    <div className="mt-8 space-y-3">
      <div className="flex items-center gap-2">
        <div className="h-6 w-1 rounded bg-[#1F3FAF]" />
        <h2 className="text-lg font-semibold text-[#1F3FAF]">Bank Details</h2>
      </div>

      <div className="rounded-xl border border-dashed border-[#9EB5E5] bg-white p-5">
        <div className="grid gap-y-3 text-sm md:grid-cols-[170px_20px_1fr]">
          <span className="font-medium">Account Holder Name</span>
          <span>:</span>
          <span>Superior Digital Pvt. Ltd.</span>

          <span className="font-medium">Account Number</span>
          <span>:</span>
          <span>625305500355</span>

          <span className="font-medium">Bank Name & Branch</span>
          <span>:</span>
          <span>ICICI Bank, Malleshwaram</span>

          <span className="font-medium">IFSC</span>
          <span>:</span>
          <span>ICIC0000078</span>

          <span className="font-medium">Account Type</span>
          <span>:</span>
          <span>Current</span>
        </div>
      </div>
    </div>
  )
}
